module.exports = __webpack_public_path__ + "img/a953100.webp";